import { Content } from '../../types';

export const battambangContent: Content = {
  title: 'בטאמבאנג – עיר היסטורית ותרבותית בצפון-מערב המדינה',
  imageUrl:
    'https://github.com/idoyef/lelo-gvulot-images/blob/master/images/cambodia/battambang/battambang-wide.png?raw=true',
  introduction: `בטאמבאנג הינה אחת הערים הגדולות והחשובות בצפון-מערב קמבודיה. היא משמשת כמרכז כלכלי ותרבותי של האזור וידועה בארכיטקטורה הקולוניאלית שלה, בשווקים הססגוניים ובסצנת האמנות המפותחת והמתפתחת שלה. העיר ממוקמת כ-300 ק"מ מהבירה פנום פן וכ-100 ק"מ מסיאם ריפ, והיא מציעה שילוב מרתק של היסטוריה, תרבות ומטבח מקומי עשיר.`,
  sections: [
    {
      title: 'היסטוריה ומורשת',
      content: `בטאמבאנג הייתה בעבר מרכז מסחרי וחקלאי חשוב, עם היסטוריה שנמשכת מאות שנים. בתקופה הקולוניאלית הצרפתית, העיר שגשגה והפכה למרכז תרבותי ואדריכלי. ניתן עדיין למצוא ברחבי העיר מבנים קולוניאליים מרשימים שמעידים על עברה המפואר. בתקופת שלטון החמר רוז', העיר סבלה מהרס רב, אך בעשורים האחרונים היא חווה תחייה מחודשת בתחומי התרבות, התיירות והאמנות.`,
      type: 'text',
    },
    {
      title: 'אטרקציות מרכזיות בבטאמבאנג',
      content: [
        {
          subtitle: 'השוק המרכזי (Psar Nat)',
          text: 'שוק תוסס שבו ניתן למצוא מכל טוב – תוצרת חקלאית מקומית, מאכלים מסורתיים, בדים, חפצי נוי ועוד. זוהי דרך מצויינת, בשילוב עם סיור במרכז העיר (בתים בסגנון קולוניאלי – צרפתי), לחוות את חיי היומיום של התושבים המקומיים.',
        },
        {
          subtitle: 'הבמבוק טריין (Norry Train)',
          text: 'אחת החוויות הייחודיות ביותר בקמבודיה – נסיעה על קרונית במבוק הנעה על מסילת רכבת ישנה. זוהי אטרקציה פופולרית המאפשרת ליהנות מנופי הכפרים והשדות הפתוחים של בטאמבאנג.',
        },
        {
          subtitle: 'מקדש ואט באנאן (Wat Banan Temple)',
          text: 'מקדש עתיק מתקופת האימפריה הקמרית, המזכיר את מקדשי אנגקור. המקדש ממוקם על ראש גבעה ומציע נוף פנורמי עוצר נשימה של האזור.',
        },
        {
          subtitle: 'מערות העטלפים בפנום סמפאו (Phnom Sampeau Bat Caves)',
          text: 'אתר טבע מיוחד שבו ניתן לצפות באלפי עטלפים היוצאים ממערה עם השקיעה, מחזה מדהים שמושך אליו תיירים רבים.',
        },
        {
          subtitle: 'כפרי האמנות והמפעלים המסורתיים',
          text: 'בטאמבאנג היא ביתם של אומנים רבים ומציעה ביקורים בסדנאות יצירה, כולל מפעלי ייצור דגים מותססים, יצירת כלי קרמיקה מסורתיים ואריגת משי.',
        },
        {
          subtitle: 'מערות הקטל (Killing Caves)',
          text: "אתר היסטורי מצמרר שבו החמר רוז' הוציאו להורג אלפי קורבנות בשנות ה-70. כיום יש במקום אנדרטה לזכר הקורבנות, המהווה עדות חשובה להיסטוריה הכואבת של קמבודיה.",
        },
        {
          subtitle: 'המוזיאון הלאומי של בטאמבאנג',
          text: 'מוזיאון קטן אך מרתק המציג ממצאים ארכאולוגיים מתקופות שונות, כולל חפצים מהאימפריה הקמרית ומידע על ההיסטוריה של האזור.',
        },
        {
          subtitle: 'הגשר הקולוניאלי על הנהר סנגקר Sangker River',
          text: 'גשר היסטורי מתקופת הקולוניאליזם הצרפתי, המהווה נקודת תצפית מצוינת על נהר סנגקר ועל חיי המקומיים שלאורכו.',
        },
        {
          subtitle: 'סיור לאורך הנהר סנגקר Sangker River',
          text: 'ניתן לשכור סירה או לצאת לטיול לאורך הנהר וליהנות מהנוף הכפרי, הבתים הצפים והחיים המקומיים המשקפים את התרבות הקמבודית המסורתית.',
        },
        {
          subtitle: 'תיאטרון Phare Ponleu Selpak',
          text: 'אחד המקומות הבולטים בסצנת התרבות של בטאמבאנג. התיאטרון מציג מופעי קרקס, מחול ומוזיקה המספרים סיפורים מקומיים ומשלבים אמנות מסורתית עם מודרנית.',
        },
      ],
      type: 'list',
    },
    {
      title: 'סצנת האמנות והתרבות',
      content: `בשנים האחרונות בטאמבאנג הפכה למרכז תרבותי ואמנותי משגשג, עם גלריות אומנות, מופעי תיאטרון ומרכזי תרבות המקדמים אמנות מקומית. אחד המקומות הבולטים הוא "Phare Ponleu Selpak", ארגון ללא מטרות רווח המשלב חינוך ואמנות כדי לסייע לנוער מקומי להתפתח בתחומי המוזיקה, הציור והקרקס.`,
      type: 'text',
    },
    {
      title: 'מטבח מקומי ואוכל רחוב',
      content: `בטאמבאנג מפורסמת גם במטבח המקומי העשיר שלה. ניתן למצוא בעיר מסעדות מקומיות ודוכני אוכל רחוב המציעים מאכלים מסורתיים כמו "פראה הוק" (דג מותסס), "לוק לאק" (בשר מוקפץ בסגנון קמבודי) ו"נום באן צ'וק" (מרק אטריות אורז עם רוטב דגים).`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `בטאמבאנג הינה יעד מושלם לאלו המבקשים לחקור את ההיסטוריה והתרבות הקמבודית באווירה שלווה ואותנטית. עם מבנים קולוניאליים, חוויות תרבותיות מרתקות, אוכל מקומי עשיר וטבע עוצר נשימה – היא מציעה חוויית טיול בלתי נשכחת בצפון-מערב קמבודיה.`,
      type: 'text',
    },
  ],
};
